'use client';
import * as Styled from './styled';
import EmailVerificationButton from '@/components/EmailVerification/EmailVerificationButton';

const EmailVerificationBanner: React.FC = () => {
  return (
    <Styled.EmailVerificationBanner>
      <b>Email verification is required to ensure the security of your account.</b>
      <div>Until verified, you have read access to browse the platform.</div>
      <EmailVerificationButton />
    </Styled.EmailVerificationBanner>
  );
};

export default EmailVerificationBanner;
